/**
 * @file wms-expiry.ts
 * @description Расчёты по срокам годности партий (phase19.13 этап 0).
 *
 * Вынесено из компонентов: одна и та же граница «критично / предупреждение»
 * используется и в фильтре вкладок, и в раскраске строк.
 */

/** Дней до истечения срока (отрицательное — партия уже просрочена). */
export function daysLeft(expiresAt: string): number {
  return Math.ceil((new Date(expiresAt).getTime() - Date.now()) / (24 * 3600 * 1000));
}

/** ≤ 7 дней — критично (красный маркер). */
export const EXPIRY_CRITICAL_DAYS = 7;

/** ≤ 30 дней — предупреждение (жёлтый маркер). */
export const EXPIRY_WARNING_DAYS = 30;
